class ShareModel {
  constructor() {
    this.mainSettings = {
      comparisonTypes: [
        { type: 'none', name: 'Price', isActive: false },
        { type: 'percent', name: 'Percent', isActive: false },
      ],

      exportOptions: [
        { type: 'pdf', name: 'Export as PDF', fileName: 'shares-chart', exportType: 'application/pdf' },
        { type: 'png', name: 'Export as PNG', fileName: 'shares-chart', exportType: 'image/png' },
        { type: 'jpeg', name: 'Export as JPEG', fileName: 'shares-chart', exportType: 'image/jpeg' },
        { type: 'svg', name: 'Export as SVG', fileName: 'shares-chart', exportType: 'image/svg+xml' },
        { type: 'print', name: 'Print graph', fileName: null, exportType: null },
      ]
    };

    this.productionSettings = {
      instruments: {
        main: [
          { symbol: 'LOYAL', marketPlace: 'FNSE', currency: 'SEK', name: 'LOYAL', uniqueId: 'LOYALFNSESEK', isDisabled: false, isActive: true, color: '#00743f' },
        ],
        index: [
          { symbol: 'FIRSTNORTHSEK', marketPlace: 'XSTO', currency: 'SEK', name: 'First North All-Share SEK', uniqueId: 'FIRSTNORTHSEKXSTOSEK', isDisabled: false, isActive: false, color: '#9a1c1c'  },
        ],
        peers: [],
      },
      indicators: [
        { uniqueId: 'RegulatoryRPT', seriesId: 'LOYALFNSESEK', name: 'Reports', isDisabled: false, isActive: false },
        { uniqueId: 'RegulatoryPRM', name: 'Press Releases', isDisabled: false, isActive: false },
        { uniqueId: 'DIVIDEND', name: 'Dividend', isDisabled: false, isActive: false }
      ],
    };

    this.developmentSettings = {
      instruments: {
        main: [
          { symbol: 'TEL2 B', marketPlace: 'XSTO', currency: 'SEK', name: 'Tele 2', uniqueId: 'TEL2BXSTOSEK', isDisabled: false, isActive: true, color: '#00743f' },
        ],
        index: [
          { symbol: 'OMXSPI', marketPlace: 'XSTO', currency: 'SEK', name: 'OMX Stockholm PI', uniqueId: 'OMXSPIXSTOSEK', isDisabled: false, isActive: false, color: '#9a1c1c' }
        ],
        peers: [],
      },

      indicators: [
        { uniqueId: 'RegulatoryRPT', seriesId: 'TEL2BXSTOSEK', name: 'Reports', isDisabled: false, isActive: false },
        { uniqueId: 'RegulatoryPRM', name: 'Press Releases', isDisabled: false, isActive: false },
        { uniqueId: 'DIVIDEND', name: 'Dividend', isDisabled: false, isActive: false }
      ],
    };
  }

  getProdSettings() {
    return {...this.productionSettings, ...this.mainSettings};
  }

  getDevSettings() {
    return {...this.developmentSettings, ...this.mainSettings};
  }
}

export default ShareModel;
